import { initializeApp } from 'firebase/app';
import { getAuth, setPersistence, inMemoryPersistence, connectAuthEmulator } from 'firebase/auth';
import { getFirestore, connectFirestoreEmulator } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getFunctions, connectFunctionsEmulator } from 'firebase/functions';


export const firebaseConfig = {
  apiKey: "AIzaSyBN2N5A2o-wsaEQ9dyKLxGg0sQOPnwiBBM",
  authDomain: "dmm-law-user-portal.web.app",
  projectId: "dmm-law-user-portal",
  storageBucket: "dmm-law-user-portal.appspot.com",
  messagingSenderId: "320160744376",
  appId: "1:320160744376:web:5ef4bd7d3950d043c2854d"
};
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
// Disable persistent login: keep auth state only in memory (clears on page reload)
setPersistence(auth, inMemoryPersistence).catch(() => {
  // Intentionally ignore persistence errors and proceed with default behavior
});
const db = getFirestore(app);
const storage = getStorage(app);
const functions = getFunctions(app, 'us-central1');

// ── Connect to local emulators only when running on localhost AND emulator env flag is enabled ────────────
const isLocal = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
// Explicit env flag to enable emulators in development builds (must be "true")
const useEmulators = process.env.VUE_APP_USE_FUNCTIONS_EMULATOR === 'true' || process.env.VUE_APP_USE_FIREBASE_EMULATORS === 'true';
if (isLocal && useEmulators) {
  console.log('🔧 Using Firebase Emulators (local development)');
  connectAuthEmulator(auth, 'http://localhost:9099', { disableWarnings: true });
  connectFirestoreEmulator(db, 'localhost', 8081);
  connectFunctionsEmulator(functions, 'localhost', 5001);
}

export { auth, db, storage, functions, app };
